<template>
  <div class="form-row">
    <el-form
      label-width="100px"
      :model="formLabelAlign"
      style="max-width: 460px"
    >
      <el-form-item label="邮箱/手机号">
        <el-input v-model="formLabelAlign.name" />
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="formLabelAlign.name" />
      </el-form-item>
      <el-form-item label="验证码">
        <el-input v-model="formLabelAlign.name">
          <template #append>
            <el-button type="primary">获取验证码</el-button>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item style="margin-left: 0; float: right">
        <el-button type="primary">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
const formLabelAlign = reactive({
  name: "",
  region: "",
  type: "",
});
</script>

<style scoped></style>
